// A deleted message stays in place as a tombstone ("(message deleted)") and its thread replies
// go (the server cascades the soft delete to them). Every conversation store applies this one.
import type { Message } from "./types.js";

export function tombstoneDeleted(messages: readonly Message[], messageId: string): Message[] {
  const out: Message[] = [];
  for (const m of messages) {
    if (m.parentId === messageId) continue;
    out.push(m.id === messageId ? { ...m, deleted: true, text: "", reactions: undefined } : m);
  }
  return out;
}
